import { cn } from "@repo/design-system/utils/cn";
import type { ReactNode } from "react";

export default function TeaserBarWrapper({
  headline,
  className,
  children,
}: {
  headline?: string;
  className?: string;
  children: ReactNode;
}) {
  return (
    <section className="outer-container flex flex-col bg-card py-container print:hidden">
      <div className="inner-container">
        {headline && (
          <h2 className={cn(className, "pb-6 lg:pb-10")}>{headline}</h2>
        )}
        <ul
          className={cn(
            "grid grid-flow-row gap-y-8 sm:grid-cols-1 md:grid-cols-3 md:gap-x-8 lg:grid-flow-col"
          )}
        >
          {children}
        </ul>
      </div>
    </section>
  );
}
